import { useEffect } from 'react';
import OInput from '../../../../../UI/FormControls/OInput';
import { useTranslation } from 'react-i18next';
import OAutocomplete from '../../../../../UI/MuiAutocomplete';
import useHttp from '../../../../../../hooks/use-http';
import { formatDateBody } from '../../../../../../../utils/FormatDate';
import styles from './inputs.module.css';
import DragAndDrop from '../../../../../UI/DragAndDrop';
import AutocompleteMulti from '../../../../../UI/AutocompleteMulti';
import TextArea from '../../../../../UI/FormControls/TextArea';

const Inputs = ({ formValue, setFormValue, idKlijenta }) => {
  const { t, i18n } = useTranslation();

  const { sendRequest: vratiTipMasine, data: tipMasineData } = useHttp('');
  const { sendRequest: vratiLokacije, data: lokacijeData } = useHttp('');
  const { sendRequest: vratiStatuse, data: statusiData } = useHttp('');
  const { sendRequest: vratiKupce, data: kupciData } = useHttp('');
  const { sendRequest: vratiKontaktOsobe, data: kontaktData } = useHttp('');
  const { sendRequest: vratiKlijentMasine, data: masineKlijnt } = useHttp('');
  const { sendRequest: vratiKlijentAlat, data: klijentAlat } = useHttp('');
  const { sendRequest: vratiKlijentProizvode, data: klijentProizvodi } =
    useHttp('');
  const { sendRequest: vratiKarakteristikeMasina, data: karakteristikeMasina } =
    useHttp('');
  const { sendRequest: vratiKorsinikTipMasine, data: korsinikTipMasine } =
    useHttp('');
  useEffect(() => {
    // const configLokacije = {
    //   url: 'Combo/vrati_lokacije_masina_combo',
    // };
    // vratiLokacije(configLokacije);

    const configKupci = {
      url: 'Combo/vrati_kupce_combo',
    };
    vratiKupce(configKupci);
    const configKontakt = {
      method: 'POST',
      url: 'Combo/vrati_kontakt_osobe',
      data: { id: 1 },
    };
    vratiKontaktOsobe(configKontakt);
  }, []);

  useEffect(() => {
    if (formValue.idTipaMasine > 0) {
      const configKarakteristikeMasina = {
        method: 'POST',
        url: 'Combo/vrati_karakteristike',
        data: { id: formValue.idTipaMasine },
      };
      vratiKarakteristikeMasina(configKarakteristikeMasina);
    }
    if (formValue.idTipaMasine > 0) {
      const configKorsinikTipMasine = {
        method: 'POST',
        url: 'Combo/vrati_korisnike_za_tip_masine',
        data: { idTipaMasine: formValue.idTipaMasine },
      };
      vratiKorsinikTipMasine(configKorsinikTipMasine);
    }
  }, [formValue.idTipaMasine]);

  useEffect(() => {
    if (
      formValue.idTipaMasine !== 0 &&
      korsinikTipMasine &&
      formValue.id === 0
    ) {
      const kontaktOsobe = korsinikTipMasine.filter(
        (x) => x.kontaktOsoba === true,
      );

      setFormValue((curr) => {
        return { ...curr, listaKonstruktora: kontaktOsobe };
      });
    }
  }, [formValue.idTipaMasine, korsinikTipMasine]);

  useEffect(() => {
    const configTipMasine = {
      url: 'Combo/vrati_tipove_masina_combo',
      method: 'POST',
      data: { metadata: i18n.language },
    };
    vratiTipMasine(configTipMasine);

    const configStatuse = {
      url: 'Combo/vrati_statuse_masina_combo',
      method: 'POST',
      data: { metadata: i18n.language },
    };
    vratiStatuse(configStatuse);
  }, [i18n.language]);

  useEffect(() => {
    const configLokacije = {
      method: 'POST',
      url: 'Combo/vrati_lokacije_za_id_kupca_combo',
      data: { id: formValue.idKupca },
    };
    vratiLokacije(configLokacije);

    const configKlijentMasine = {
      method: 'POST',
      url: 'Combo/vrati_klijent_masine_za_id_klijenta',
      data: { id: formValue.idKupca },
    };
    vratiKlijentMasine(configKlijentMasine);

    const configKlijentAlat = {
      method: 'POST',
      url: 'Combo/vrati_klijent_alat_za_id_klijenta',
      data: { id: formValue.idKupca },
    };
    vratiKlijentAlat(configKlijentAlat);

    const configKlijentProizvod = {
      method: 'POST',
      url: 'Combo/vrati_klijent_proizvod_za_id_klijenta ',
      data: { id: formValue.idKupca },
    };
    vratiKlijentProizvode(configKlijentProizvod);
  }, [formValue.idKupca]);
  useEffect(() => {
    if (idKlijenta && kupciData.length > 0) {
      console.log(kupciData);
      const defaultKupac = kupciData?.find((item) => item.id === idKlijenta);
      setFormValue((curr) => {
        return {
          ...curr,
          idKupca: defaultKupac.id,
          kupac: defaultKupac.vrednost,
        };
      });
    }
  }, [kupciData]);

  const handleChange = (item) => {
    setFormValue((curr) => {
      return { ...curr, [item.target.name]: item.target.value };
    });
  };
  const handleClickTipMasine = (item) => {
    if (item.vrednost !== 'Robot') {
      setFormValue((curr) => {
        return {
          ...curr,
          idTipaMasine: item.id,
          tipMasine: item.vrednost,
          listaKlijentAlat: [],
          listaKarakteristika: [],
          listaKonstruktora: [],
        };
      });
    } else {
      setFormValue((curr) => {
        return {
          ...curr,
          idTipaMasine: item.id,
          tipMasine: item.vrednost,
          listaKarakteristika: [],
          listaKonstruktora: [],
        };
      });
    }
  };
  const handleClickKupci = (item) => {
    setFormValue((curr) => {
      return {
        ...curr,
        idKupca: item.id,
        kupac: item.vrednost,
        idLokacije: 0,
        lokacija: '',
      };
    });
  };
  const handleClickLokacija = (item) => {
    setFormValue((curr) => {
      return { ...curr, idLokacije: item.id, lokacija: item.vrednost };
    });
  };
  const handleClickKontakt = (item) => {
    setFormValue((curr) => {
      return { ...curr, idKontaktOsoba: item.id, kontaktOsoba: item.vrednost };
    });
  };
  const handleClickStatus = (item) => {
    setFormValue((curr) => {
      return { ...curr, idStatusaMasine: item.id, status: item.vrednost };
    });
  };
  const handleFiles = (files) => {
    setFormValue((curr) => {
      return { ...curr, files: files };
    });
  };
  const handleDeleteFile = () => {
    setFormValue((curr) => {
      return { ...curr, files: [] };
    });
  };
  const handleClickMasineKlijen = (e) => {
    setFormValue((curr) => {
      return { ...curr, listaKlijentMasina: e };
    });
  };
  const handleClickKarakteristikeMasina = (e) => {
    setFormValue((curr) => {
      return { ...curr, listaKarakteristika: e };
    });
  };
  const handleClickKorsinikTipMasine = (e) => {
    setFormValue((curr) => {
      return { ...curr, listaKonstruktora: e };
    });
  };
  const handleClickMasineAlat = (e) => {
    setFormValue((curr) => {
      return { ...curr, listaKlijentAlat: e };
    });
  };
  const handleClickMasineProizvodi = (e) => {
    setFormValue((curr) => {
      return { ...curr, listaKlijentProizvod: e };
    });
  };
  console.log(formValue);
  return (
    <div>
      <OAutocomplete
        data={tipMasineData}
        value={formValue.tipMasine}
        handleClick={handleClickTipMasine}
        // label={t('machineType')}
        label={`${t('machineType')} *`}
        style={{ width: '100%' }}
        touched={formValue.touchedTipMasine}
        setTouched={() => {
          setFormValue((curr) => {
            return { ...curr, touchedTipMasine: true };
          });
        }}
        errorMessage={`${t('machineType')} ${t('isRequired')}`}
      />
      <OAutocomplete
        data={kupciData}
        value={formValue.kupac}
        handleClick={handleClickKupci}
        // label={t('client')}
        label={`${t('client')} *`}
        style={{ width: '100%' }}
      />
      <AutocompleteMulti
        options={masineKlijnt}
        value={formValue.listaKlijentMasina || []}
        textProperty="vrednost"
        onChange={handleClickMasineKlijen}
        text="Mašine"
        style={{ width: '100%' }}
      />
      <AutocompleteMulti
        options={karakteristikeMasina}
        value={formValue.listaKarakteristika || []}
        textProperty="vrednost"
        onChange={handleClickKarakteristikeMasina}
        text="Karakteristike"
        style={{ width: '100%' }}
      />
      <AutocompleteMulti
        options={korsinikTipMasine}
        value={formValue.listaKonstruktora || []}
        textProperty="vrednost"
        onChange={handleClickKorsinikTipMasine}
        text="U chatu"
        style={{ width: '100%' }}
      />
      {formValue.tipMasine === 'Robot' && (
        <AutocompleteMulti
          options={klijentAlat}
          value={formValue.listaKlijentAlat || []}
          textProperty="vrednost"
          onChange={handleClickMasineAlat}
          text="Alati"
          style={{ width: '100%' }}
        />
      )}
      <AutocompleteMulti
        options={klijentProizvodi}
        value={formValue.listaKlijentProizvod || []}
        textProperty="vrednost"
        onChange={handleClickMasineProizvodi}
        text="Proizvodi"
        style={{ width: '100%' }}
      />
      <OInput
        label={`Oznaka ${
          formValue.tipMasine === ''
            ? ''
            : formValue.tipMasine === 'Robot'
            ? 'robota'
            : 'alata'
        } *`}
        name="sifra"
        value={formValue.sifra}
        handleChange={handleChange}
        touched={formValue.touchedSifra}
        setTouched={() => {
          setFormValue((curr) => {
            return { ...curr, touchedSifra: true };
          });
        }}
        errorMessage={`${t('machineRobotMachine')} ${t('isRequired')}`}
        style={{ width: '100%' }}
      />
      <OInput
        label={`${t('serialNumber')}`}
        name="serijskiBroj"
        value={formValue.serijskiBroj}
        handleChange={handleChange}
        touched={formValue.touchedSerijskiBroj}
        setTouched={() => {
          setFormValue((curr) => {
            return { ...curr, touchedSerijskiBroj: true };
          });
        }}
        errorMessage={`${t('serialNumber')} ${t('isRequired')}`}
        style={{ width: '100%' }}
      />
      <OInput
        label={`Interna oznaka ${
          formValue.tipMasine === ''
            ? ''
            : formValue.tipMasine === 'Robot'
            ? 'robota'
            : 'alata'
        }`}
        name="oznakaKupac"
        value={formValue.oznakaKupac}
        readonly
        style={{ width: '100%' }}
      />
      {/* <OInput
        label={`${t('machineName')} *`}
        name="naziv"
        value={formValue.naziv}
        handleChange={handleChange}
        touched={formValue.touchedNaziv}
        setTouched={() => {
          setFormValue((curr) => {
            return { ...curr, touchedNaziv: true };
          });
        }}
        errorMessage={`${t('machineName')} ${t('isRequired')}`}
        style={{ width: '100%' }}
      /> */}
      <OAutocomplete
        data={lokacijeData}
        value={formValue.lokacija}
        handleClick={handleClickLokacija}
        label={t('location')}
        style={{ width: '100%' }}
      />
      <OAutocomplete
        data={kontaktData}
        value={formValue.kontaktOsoba}
        handleClick={handleClickKontakt}
        label={t('contactPerson')}
        style={{ width: '100%' }}
      />
      <div className={styles.dateContainer}>
        <OInput
          label={`${t('datePurchase')}`}
          style={{ width: '49%', marginRight: '15px' }}
          handleChange={handleChange}
          type="date"
          value={formatDateBody(formValue.datumKupovine)}
          name="datumKupovine"
          touched={formValue.touchedDatumKupovine}
          setTouched={() => {
            setFormValue((curr) => {
              return { ...curr, touchedDatumKupovine: true };
            });
          }}
          errorMessage={`${t('datePurchase')} ${t('isRequired')}`}
        />
        <OInput
          label={`${t('warranyDate')} (${t('months')}) `}
          style={{ width: '49%' }}
          handleChange={handleChange}
          type="number"
          value={formValue.trajanjeGarancije}
          name="trajanjeGarancije"
          touched={formValue.toucheTtrajanjeGarancije}
          setTouched={() => {
            setFormValue((curr) => {
              return { ...curr, toucheTtrajanjeGarancije: true };
            });
          }}
          errorMessage={`${t('warranyDate')} ${t('isRequired')} `}
        />
      </div>
      <OAutocomplete
        data={statusiData}
        value={formValue.status}
        handleClick={handleClickStatus}
        label={t('status')}
        style={{ width: '100%' }}
      />
      <TextArea
        label="Opis"
        rows="8"
        name="dodatneInformacije"
        value={formValue.dodatneInformacije}
        handleChange={handleChange}
        style={{ width: '100%', height: '150px' }}
      />
      <div className={styles.fileContainer}>
        <DragAndDrop
          handleFiles={handleFiles}
          maxFiles={1}
          addedFiles={formValue.files}
          handleRemoveFile={handleDeleteFile}
          title="Dodavanje slike mašine"
        />
        <img
          alt=""
          src={formValue.slikaUrl}
          style={{ height: '175px', maxWidth: '230px' }}
        />
      </div>
    </div>
  );
};

export default Inputs;
